var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11221_18217)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35706 1.72042L7.51506 4.04992C7.57306 4.16742 7.68506 4.24942 7.81506 4.26842L10.4076 4.64292C10.5126 4.65692 10.6071 4.71192 10.6716 4.79592C10.7926 4.95342 10.7741 5.17642 10.6291 5.31192L8.75006 7.12892C8.65456 7.21892 8.61206 7.35092 8.63706 7.47942L9.08706 10.0434C9.11856 10.2559 8.97356 10.4549 8.76106 10.4894C8.67306 10.5029 8.58306 10.4889 8.50306 10.4494L6.19406 9.23892C6.07806 9.17592 5.93906 9.17592 5.82306 9.23892L3.49706 10.4559C3.30256 10.5549 3.06456 10.4814 2.95856 10.2909C2.91806 10.2139 2.90406 10.1264 2.91806 10.0409L3.36806 7.47692C3.39056 7.34892 3.34806 7.21742 3.25506 7.12692L1.36606 5.31042C1.21206 5.15742 1.21106 4.90842 1.36456 4.75442L1.36606 4.75242C1.42956 4.69492 1.50756 4.65642 1.59206 4.64142L4.18506 4.26692C4.31456 4.24642 4.42606 4.16542 4.48506 4.04792L5.64206 1.72042C5.68856 1.62592 5.77106 1.55342 5.87106 1.52042C5.97156 1.48692 6.08156 1.49492 6.17606 1.54242C6.25356 1.58092 6.31706 1.64342 6.35706 1.72042Z",
    stroke: "#1662E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11221_18217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue_star.5a4a464a.svg";
export { ForwardRef as ReactComponent };